// Lets a page (e.g. Sales Entry) intercept in-app navigation when it has unsaved data
let guard = null;

export const setNavigationGuard = (fn) => { guard = fn; };

export const runNavigationGuard = (proceed) => (guard ? guard(proceed) : proceed());

export const hasNavigationGuard = () => !!guard;
